/*
 * wim-analytics-centers.js
 *
 * Instrumenta el localizador de centros como micro-funnel: visita a la página,
 * búsqueda y salida hacia un centro.
 *
 * La página es hoy contenido libre sin marcado identificativo, así que el nombre
 * del centro se deriva del texto más cercano al enlace. Para una lectura fiable
 * conviene añadir data-wim-center="<nombre>" en el contenedor de cada centro:
 * si está presente, tiene prioridad sobre la heurística.
 */

(function () {
  'use strict';

  var INIT_FLAG = 'wimAnalyticsCentersInit';
  if (window[INIT_FLAG]) return;
  window[INIT_FLAG] = true;

  var TEMPLATE_MATCH = 'localizador';

  var dl = (window.dataLayer = window.dataLayer || []);

  function context() {
    return window.wimAnalyticsContext || {};
  }

  /* Los eventos propios se publican con prefijo para no colisionar con los
     que emite el canal de Google. El nombre estándar se aplica en la etiqueta,
     al enviar a la analítica. El objeto de comercio electrónico se limpia antes
     de cada envío para que no arrastre valores del mensaje anterior. */
  function push(name, payload) {
    dl.push({ ecommerce: null });
    dl.push(Object.assign({ event: 'wim_' + name, wim_source: 'theme' }, context(), payload || {}));
  }

  var template = String(context().page_template || '');
  if (template.indexOf(TEMPLATE_MATCH) === -1) return;

  var root = document.querySelector('main') || document.body;

  /* Clasifica el destino de un enlace de salida hacia un centro */
  function outboundType(href) {
    if (/^tel:/i.test(href)) return 'phone';
    if (/^mailto:/i.test(href)) return 'email';
    if (/(google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps)/i.test(href)) return 'directions';
    if (/^https?:/i.test(href) && href.indexOf(window.location.hostname) === -1) return 'website';
    return null;
  }

  /* Nombre del centro: atributo explícito si existe, si no el encabezado más
     cercano por encima del enlace. */
  function centerName(link) {
    var marked = link.closest('[data-wim-center]');
    if (marked) return marked.getAttribute('data-wim-center');

    var block = link.closest('li, article, .card, div');
    var heading = block && block.querySelector('h2, h3, h4, strong');
    return heading ? heading.textContent.trim().slice(0, 100) : '';
  }

  push('view_center_locator', {
    centers_count: root.querySelectorAll('[data-wim-center]').length || undefined
  });

  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var type = outboundType(href);
    if (!type) return;

    push('center_outbound', {
      center_name: centerName(link),
      outbound_type: type
    });
  });

  var search = root.querySelector('input[type="search"], input[name*="search"], input[name*="buscar"]');
  if (search) {
    var timer = null;
    search.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var term = search.value.trim();
        if (term.length < 3) return;
        push('center_search', { search_term: term.slice(0, 100) });
      }, 900);
    });
  }
})();
